module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-2.899789a0.jpg";